import chunk from 'lodash/fp/chunk'

export default function (pageSize, collection, currentPage) {
  return chunk(pageSize, collection)[currentPage - 1]
}